import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Buffer } from "buffer";
import process from "process";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import Resume from "./Resume";
import StealthLanding from "./StealthLanding";
import WorkingManPage from "./working-man/WorkingManPage";

Amplify.configure(awsExports);

window.process = process;
window.Buffer = Buffer;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/resume" element={<Resume />} />
        <Route path="/index" element={<StealthLanding />} />
        <Route path="/" element={<WorkingManPage />} />
      </Routes>
    </Router>
  );
}

export default App;
